import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center h-100" }
const _hoisted_2 = { style: {"font-size":"3vh"} }
const _hoisted_3 = { class: "d-flex w-100 h-100" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column align-center justify-center h-100 w-100"
}
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-column align-center justify-center h-100 w-100",
  style: {"font-size":"3vh"}
}
const _hoisted_6 = {
  class: "px-1 h-100",
  style: {"width":"80%"}
}
const _hoisted_7 = ["id"]
const _hoisted_8 = {
  class: "d-flex flex-column align-center justify-center h-100",
  style: {"width":"20%"}
}
const _hoisted_9 = { class: "d-flex align-center justify-space-evenly w-100" }
const _hoisted_10 = { style: {"font-size":"5vh"} }

import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { computed, nextTick, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AnalysisResultPanel',
  props: {
    title: {},
    canvasId: {},
    chartLabels: {},
    chartData: {},
    limitValue: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const limitData = computed(() => {
  return props.chartData.map((value) => {
    return props.limitValue;
  });
});

const lastDifferencePercentage = computed(() => {
  if (props.chartData.length < 2) return 0;
  const lastValue = props.chartData[props.chartData.length - 1];
  const previousValue = props.chartData[props.chartData.length - 2];
  const difference = lastValue - previousValue;
  const percentage = (difference / previousValue) * 100;
  return Math.abs(Math.round(percentage));
});

const lastDifferencePositive = computed(() => {
  if (props.chartData.length < 2) return false;
  const lastValue = props.chartData[props.chartData.length - 1];
  const previousValue = props.chartData[props.chartData.length - 2];
  return lastValue > previousValue;
});

const lastValueGood = computed(() => {
  if (props.chartData.length < 1) return false;
  const lastValue = props.chartData[props.chartData.length - 1];
  return lastValue <= props.limitValue;
});

let chart: Chart | null = null;

watch(
  () => props.chartData,
  () => {
    if (props.chartData.length === 0 || props.chartLabels.length === 0) return;

    initializeChart();
  },
  { once: true, deep: true }
);

async function initializeChart() {
  await nextTick();

  const canvas = document.getElementById(props.canvasId) as HTMLCanvasElement;
  if (!canvas) {
    console.warn("Canvas com ID 'graficoTempo' não encontrado.");
    return;
  }

  const ctx = canvas.getContext("2d");

  chart = new Chart(ctx!, {
    data: {
      labels: props.chartLabels,
      datasets: [
        {
          type: "line",
          label: `Padrão IAT/PR (${props.limitValue})`,
          data: limitData.value,
          borderColor: "#4CAF50",
          backgroundColor: "#4CAF50",
          pointRadius: 0,
          borderWidth: 3,
        },
        {
          type: "bar",
          label: props.title,
          data: props.chartData,
          borderColor: "#2196F3",
          backgroundColor: "#2196F3",
          borderWidth: 1,
        },
      ],
    },
    plugins: [ChartDataLabels],
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 0,
          bottom: 10,
          left: 40,
          right: 0,
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            padding: 20,
            font: function (context) {
              const width = context.chart.width;
              const size = Math.round(width / 50);

              return {
                weight: "bold",
                size: size,
              };
            },
          },
        },
        title: {
          display: false,
        },
        datalabels: {
          display: function (context) {
            return context.datasetIndex == 1;
          },
          color: function (context) {
            const index = context.dataIndex;
            const value = context.dataset.data[index] as number;
            return value <= props.limitValue ? "#4CAF50" : "#F44336";
          },
          font: function (context) {
            const width = context.chart.width;
            const size = Math.round(width / 50);

            return {
              weight: "bold",
              size: size,
            };
          },
          align: "end",
          anchor: "end",
        },
      },
      scales: {
        x: {
          display: true,
          grid: {
            display: false,
          },
          ticks: {
            color: "black",
            font: function (context) {
              const width = context.chart.width;
              const size = Math.round(width / 60);

              return {
                weight: "bold",
                size: size,
              };
            },
          },
        },
        y: {
          display: true,
          min: 0,
          ticks: {
            padding: 10,
            color: "black",
            font: function (context) {
              const width = context.chart.width;
              const size = Math.round(width / 60);

              return {
                weight: "bold",
                size: size,
              };
            },
          },
        },
      },
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "w-100 h-100 pa-1" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_progress_circular, { indeterminate: "" }),
                _cache[0] || (_cache[0] = _createElementVNode("span", { style: {"font-size":"2vh"} }, "Carregando dados...", -1))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.chartLabels.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_v_icon, {
                  class: "text-grey",
                  icon: "mdi-alert-circle"
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-grey-darken-3 font-weight" }, "Dados Indisponíveis", -1))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.chartLabels.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("canvas", {
                    style: {"margin":"0px 0 0 -30px"},
                    id: _ctx.canvasId
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_sheet, {
                    height: "10vh",
                    width: "14vh",
                    border: "",
                    style: {"border-color":"#424242"},
                    class: "d-flex flex-column align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createTextVNode(_toDisplayString(lastDifferencePercentage.value), 1),
                          _cache[2] || (_cache[2] = _createElementVNode("span", { style: {"font-size":"2vh"} }, "%", -1))
                        ]),
                        _createVNode(_component_v_avatar, {
                          color: lastValueGood.value ? 'success' : 'error',
                          style: {"height":"4.5vh","width":"4.5vh"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "4vh",
                              icon: 
                      lastDifferencePositive.value
                        ? 'mdi-arrow-top-right-thin'
                        : 'mdi-arrow-bottom-right-thin'
                    
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex align-center justify-space-evenly w-100 bg-grey-darken-3 flex-grow-1" }, [
                        _createElementVNode("span", { style: {"font-size":"1.5vh"} }, "Última Comparação")
                      ], -1))
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})